import { styled } from '@mui/material'

export const TabDivider = styled('div')({
  padding: 16,
})

export const FooterContainer = styled('div')({
  display: 'flex',
  justifyContent: 'flex-end',
  width: '100%',
})

export const Root = styled('div')({
  width: '100%',
})
